import { useCallback, useMemo } from 'react';
import { useNavigate, useSearch } from '@tanstack/react-router';
import {
  useLocationService,
  useLocationHistory,
  type LocationServiceLocationItem,
  LocationPickerTray,
  usePinnedLocations,
} from '@frontend/wam-location-service';
import { createFileRoute } from '../../utils/route-factory';

function LocationPicker() {
  const { currentLocation, setCurrentLocationId } = useLocationService();
  const { locations: recentLocations, addLocation } = useLocationHistory();
  const { locations: pinnedLocations } = usePinnedLocations();
  const navigate = useNavigate();
  const search = useSearch({ from: '/location/' });

  const onChangeLocation = useCallback(
    (location: LocationServiceLocationItem) => {
      setCurrentLocationId(location.locationId);
      addLocation(location);

      // Navigate to redirect URL if provided, otherwise go to global-settings
      const redirectTo = (search as any)?.redirect || '/global-settings';
      navigate({ to: redirectTo as any });
    },
    [addLocation, navigate, search, setCurrentLocationId]
  );

  const itemSections = useMemo(() => {
    return [
      {
        heading: 'Pinned Locations',
        items: pinnedLocations,
      },
      {
        heading: 'Recently Visited',
        items: recentLocations.filter((r) => !pinnedLocations.some((p) => p.locationId === r.locationId)),
      },
    ];
  }, [recentLocations, pinnedLocations]);

  return (
    <section css={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <LocationPickerTray
        hideCloseActions={true}
        currentLocation={currentLocation}
        itemSections={itemSections}
        onChangeLocation={onChangeLocation}
      />
    </section>
  );
}

export const Route = createFileRoute({ path: '/location/', component: LocationPicker, type: 'auth' });
